<template>
    <LayoutCookieConsentWrapper
        type="audio"
        disabled-message="Accept cookies to view this playlist."
        wrapper-classes="aspect-video w-full"
        class="embed-spotify-playlist"
    >
        <iframe
            :src="`https://open.spotify.com/embed/playlist/${idPlaylist}`"
            class="aspect-video w-full"
            allowfullscreen
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
        ></iframe>
    </LayoutCookieConsentWrapper>
</template>

<script>
export default {
    name: 'EmbedSpotifyPlaylist',
    props: {
        idPlaylist: {
            type: String,
            required: true
        }
    },
};

</script>
